export enum USER_ACCESS_TYPES {
    ACCOUNT_MANAGER = 'ACCOUNT_MANAGER',
    PROJECT_MANAGER = 'PROJECT_MANAGER',
    DEFAULT = 'PROJECT_MANAGER'
}

export enum USER_STATUS {
    ACTIVE = 'active',
    INVITED = 'invited'
}
interface UserBase {
    id: number;
    email: string;
    accessType: USER_ACCESS_TYPES;
    firstName: string;
    lastName?: string;
    company: string;
    jobTitle?: string;
    profilePicture?: string;
    createdDate: string;
    status: USER_STATUS;
}
export interface ActiveUser extends UserBase {
    status: USER_STATUS.ACTIVE;
    accountUrl: string; // @TODO: remove (just use tenantUrl)
}
export interface InvitedUser extends UserBase {
    status: USER_STATUS.INVITED;
    tenantName: string;
}
export type User = ActiveUser | InvitedUser;
